import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { WebhookDelivery } from "types/generated";

const WebhookDeliveriesTableIdCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<WebhookDelivery>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./delivery/${item.id}`}>{item.id}</TableCellLink>
    </TableSimpleCell>
  );
};

export default WebhookDeliveriesTableIdCell;
